/**
 * Created by Daniela on 27/09/2016.
 */
import { Component }   from '@angular/core';

@Component({
    template: require('./material-especificacao.component.html')
})
export class MaterialEspecificacaoComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-especificacao/material-especificacao.component.ts
 **/